module.exports = __webpack_public_path__ + "img/pcbanner_zh_CN.48473269.jpg";